export interface ProyectoState {
    asesorias: any[];
    citas: any[];
    loading: boolean;
    error: string | null;
}

export const state: ProyectoState = {
    asesorias: [],
    citas: [],
    loading: false,
    error: null,
};